module.exports = __webpack_public_path__ + "static/media/image-3.b5179a5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/StateofSocial/image-3.jpg
// module id = 483
// module chunks = 0